import React, { PropsWithChildren } from "react";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay.tsx";
import { PAGE_SPINNER_MARGIN_FROM_TOP } from "common/constants.ts";
import { useTheme } from "styled-components";
import { useBottomNavigator } from "utils/hooks/misc.tsx";

const SuspenseLoading = ({ children }: PropsWithChildren) => {
  const theme = useTheme();
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();

  return (
    <React.Suspense
      fallback={
        <LoadingSpinnerOverlay
          isLoading={true}
          spinnerMarginTop={
            isBottomNavigator ? undefined : PAGE_SPINNER_MARGIN_FROM_TOP
          }
          spinnerSize="large"
          wrap={true}
          hideContentWhileLoading={true}
          backgroundColor={theme.colors.layoutBgColor}
          wrapStyle={{ flex: 1 }}
        />
      }
    >
      {children}
    </React.Suspense>
  );
};

export default SuspenseLoading;
